
<mat-toolbar class="profileNavBar" color="secondary">
  <div class="profile">
    <img class="profile-img" src="..\assets\profileImage\profile-user.svg">
    <div class="profile-info">
      <p>{{signatoryName}}</p>
      <p>{{signatoryEmail}}</p>

    </div>

<div class="langue">
  <div class ="displayedLanguage">
    <img class = "iconLanguage"
      [src]="'assets/flags/' + selectedLanguage + '.svg'"
      [alt]="selectedLanguage + ' flag'"
      (click)="toggleDropdown()"
    />

    <div  class = "showDropdown"
      *ngIf="showDropdown"
    >
      <div
        *ngFor="let lang of languages"
        style="margin-bottom: 5px; cursor: pointer;"
        (click)="changeLanguage(lang.code)"
      >
        <img
          [src]="'assets/flags/' + lang.flag"
          [alt]="lang.code + ' flag'"
          style="height: 20px; margin-right: 5px;"
        />
      {{  lang.langue}}
      </div>
    </div>
  </div>
</div>

  </div>

</mat-toolbar>
<div class="toolbar">
  <div class="consent">
    <p class="record" *ngIf="timeOut && !action && !hideContinue">{{ 'CONSENTEMENT_LIRE_DOCUMENT' | translate }}</p>
    <mat-checkbox *ngIf="activeButtons && timeOut && !action" [(ngModel)]="checked" class="example-margin">
      {{ 'ACCEPTER_CONDITIONS_SIGNATURE_ELECTRONIQUE' | translate }}
    </mat-checkbox>
  </div>
  <div class="spacer">
  </div>
  <div>
    <button (click)="enableSign(activeButtons)" *ngIf="timeOut && !action && !hideContinue" [disabled]="!checked" class="continue-btn esign-btn">
      {{ 'BOUTON_CONTINUER' | translate }}
  </button>
  </div>
</div>
<div class="content" role="main">
  <app-esign-pdf (profilInformation)="receiveprofilInformation($event)"
    [activeSignRefuse]="activeButtons" (timeOut)= "receiveTimeOut($event)"  (signRefuse)='receiveSignRefuse($event)'>
  </app-esign-pdf>
</div>
